import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
//import { AdministrativoClientesComponent } from "./administrativo-clientes.component";
import { AuthGuard } from "@app/guards/auth.guard";
import { AdministrativoClientesListaComponent } from "./lista-clientes/administrativo-clientes-lista.component";
import { AdministrativoClientesFormularioComponent } from "./form-clientes/administrativo-clientes-formulario.component";
import { AdministrativoClientesLayoutComponent } from "./administrativo-clientes-layout/administrativo-clientes-layout.component";

const administrativoClienteRotas: Routes = [
  { path: '', component: AdministrativoClientesLayoutComponent, canActivate: [AuthGuard], children: [
    { path: '', component: AdministrativoClientesListaComponent, canActivate: [AuthGuard] },
    { path: 'lista', component: AdministrativoClientesListaComponent, canActivate: [AuthGuard] },
    { path: 'novo-usuario', component: AdministrativoClientesFormularioComponent, canActivate: [AuthGuard] },
  ]},
];

@NgModule({
  imports: [RouterModule.forChild(administrativoClienteRotas)],
  exports: [RouterModule]
})
export class AdministrativoClientesRoutingModule { }
